<template>
  <div
    class="kf-container"
    :class="classes"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'KfContainer',
  props: {
    containerSize: {
      type: String,
      default: '',
    },
    noPadding: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    classes() {
      return [
        this.containerSize ? `has-size-${this.containerSize}` : undefined,
        this.noPadding ? `no-padding` : null,
      ];
    }
  }
};
</script>

<style lang="postcss">
.kf-container {
  @apply container mx-auto px-5;

  &.has-size-md {
    @apply max-w-3xl;
  }

  &.no-padding {
    @apply px-0;
  }
}
</style>
